import script from "./WCBasicStickyAlert.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCBasicStickyAlert.vue?vue&type=script&setup=true&lang=ts"

import "./WCBasicStickyAlert.vue?vue&type=style&index=0&id=93cbfde2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93cbfde2"]])

export default __exports__